import CityPageTemplate from "../city-template/CityPageTemplate";
import { parkerConfig } from "./data";

export default function ParkerPage() {
  return <CityPageTemplate config={parkerConfig} />;
}